import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UXSlice, headerFindBtnTooltipShownSelector } from 'src/shared/ux';
import { useNavigateToCatalog } from 'src/features/catalog';

const VISIBILITY_ANIMATION_DURATION_IN_MS = 3000;

export const useHeaderFindBtnTooltipShown = () => {
  const dispatch = useDispatch();
  const [isMessageVisible, setMessageVisible] = React.useState(false);
  const isHeaderFindBtnTooltipShown = useSelector(headerFindBtnTooltipShownSelector);
  const { isLoading, navigateToCatalog } = useNavigateToCatalog();

  React.useEffect(() => {
    if (!isHeaderFindBtnTooltipShown) {
      const timer = setTimeout(() => {
        setMessageVisible(true);
      }, VISIBILITY_ANIMATION_DURATION_IN_MS);
      return () => clearTimeout(timer);
    }
  }, [isHeaderFindBtnTooltipShown]);

  const handleClick = () => {
    if (!isHeaderFindBtnTooltipShown) {
      dispatch(UXSlice.actions.setTooltipShown(true));
      setMessageVisible(false);
    }
    navigateToCatalog();
  };

  return { handleClick, setMessageVisible, isLoading, isMessageVisible };
};
